import styled from '@emotion/styled';

const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: auto;
`;

const CenteredContainer = styled.div`
  text-align: center;
  max-width: 410px;
`;

const StepBlock = styled.div<{ margin: string }>`
  align-items: center;
  display: flex;
  height: auto;
  margin: ${({ margin }) => margin};
  width: 100%;
`;
StepBlock.defaultProps = {
  margin: 'unset',
};

export { CenteredContainer, Container, StepBlock };
